import { useQuery } from 'react-query'

import { CacheKeys } from '../../helpers/cacheKeys'
import { getPolicyDocuments } from '../../models/repayments'

export function useRepaymentPolicyDocuments(policyId: string | undefined) {
  const { data = [], refetch } = useQuery(
    `${CacheKeys.POLICY_DOCUMENTS}-${policyId}`,
    () => getPolicyDocuments(policyId),
    {
      enabled: Boolean(policyId),
      refetchOnWindowFocus: false,
      retry: true,
      retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
    }
  )

  return {
    policyDocuments: data,
    refetch,
  }
}
